import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';
import IconTimes from '@remote-com/norma/icons/times.svg';
import { ButtonIcon } from 'remote-com-shared/components/Button';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { fromTabletBreakpoint } from '../shared/breakpoints';

import { InternationalPricingTable } from '@/src/domains/pricing/InternationalPricingTable';

const PricingDialogOverlay = styled(DialogOverlay)`
  z-index: 2; // Over fixed hero
  background-color: rgba(23, 18, 55, 0.8);
`;

const PricingDialogContent = styled(DialogContent)`
  border-radius: 10px;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  width: 95vw;
  max-width: 800px;

  ${fromTabletBreakpoint(css`
    margin-top: 10vh;
    margin-bottom: 10vh;
    ${fluidProp(['padding-top', 'padding-bottom'], '15px', '100px')}
    ${fluidProp(['padding-left', 'padding-right'], '15px', '100px')}
  `)}
`;

const InternationalPricingTitle = styled.h2`
  ${({ theme }) => theme.typography.titleXXL}
  ${fluidProp(['font-size'], '20px', '28px')}
  font-weight: 600;
  max-width: 520px;
  margin-bottom: 16px;
`;

function CloseButton(props) {
  return <ButtonIcon {...props} Icon={IconTimes} label="Close" />;
}

const PricingCloseButton = styled(CloseButton)`
  float: right;
`;

export function PricingDialog({ pricing, onDismiss, ...props }) {
  return (
    <PricingDialogOverlay onDismiss={onDismiss} {...props}>
      <PricingDialogContent aria-label="International pricing">
        <PricingCloseButton onClick={onDismiss} />
        <InternationalPricingTitle>
          Pricing per employee, per month, based on country selection
        </InternationalPricingTitle>
        <InternationalPricingTable pricing={pricing} />
      </PricingDialogContent>
    </PricingDialogOverlay>
  );
}
